import React, { PureComponent } from 'react'
import { Button, Modal, Col } from 'react-bootstrap'
import { reduxForm } from 'redux-form'
import { Link } from 'react-router-dom'
import SimpleTablePage from '../../../../containers/commons/general/SimpleTablePage'
import { compareValues } from '../../../../util/utils'
import { fleetsTab } from '../../../../constants/management/fleets'

class ConditionDetailsFleetModal extends PureComponent {
  constructor () {
    super()
    this.state = {
      filters: {
        orderBy: '+number'
      },
      dataId: null,
      fieldsDate: ['creationDate', 'lastUpdateDate']
    }
  }

  componentDidUpdate () {}

  getSnapshotBeforeUpdate (prevProps) {
    if ((this.props.showModal !== prevProps.showModal && this.props.showModal) || (this.props.showModal && this.props.tabActiveKey === fleetsTab.FLEETS_CONDITIONS && prevProps.tabActiveKey !== fleetsTab.FLEETS_CONDITIONS)) {
      this.props.actions.fetchConditionDetailsFleet(this.props.conditionFleet.documentTypeUseId, this.props.conditionFleet.conditionNoDocumentalId, this.props.dossierList)
    }

    if (this.props.showModal && this.props.tabActiveKey !== fleetsTab.FLEETS_CONDITIONS) {
      this.props.openConditionsFleetComponent(this.props.dossierList)
    }
    return null
  }

  getIconClass (field) {
    if (this.state.filters.orderBy.includes(field)) {
      return this.state.filters.orderBy.includes('-') ? 'ico-sort-selected-asc' : 'ico-sort-selected-desc'
    } else {
      return 'ico-sort'
    }
  }

  onOrderChange (e) {
    const newOrderBy = this.state.filters.orderBy.includes(`+${e.currentTarget.dataset.field}`) ? `-${e.currentTarget.dataset.field}` : `+${e.currentTarget.dataset.field}`
    this.setState({ filters: { orderBy: newOrderBy } })
    this.order(e.currentTarget.dataset.field, newOrderBy.includes('+') ? 'asc' : 'desc')
  }

  order (field, order) {
    let dossiers = JSON.parse(JSON.stringify(this.props.conditionDetails))
    dossiers = dossiers.sort(compareValues(field, order, this.state.fieldsDate.includes(field)))

    this.props.actions.fetchConditionDetailsFleetSuccess(dossiers)
  }

  closeModal () {
    this.props.initialize()
    this.props.actions.closeConditionDetailsFleetModal()
  }

  render () {
    const {
      t,
      showModal, conditionDetails, stageName, conditionFleet
    } = this.props
    const tKey = 'MANAGEMENT.FLEETS_TAB.'
    const tSubKey = 'AUX_MODALS.'

    if (showModal && conditionDetails) {
      return (
        <Modal id="conditionDetailsFleetModal" className="_nf" show={showModal} onHide={() => this.closeModal()} backdrop={'static'}>
          <Modal.Header closeButton onHide={() => this.closeModal()}>
            <Modal.Title>{t(`${tKey}${tSubKey}CONDITION_DETAILS_FLEET_MODAL`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='infoBlock'>
              <div className='infoRight'>
                <div className='infoItem'><p><span>{t(`${tKey}STAGE`)}:</span>{stageName}</p></div>
                <div className='infoItem'><p><span>{t(`${tKey}CONDITION`)}:</span>{conditionFleet.condition}</p></div>
                <div className='infoItem'><p><span>{t(`${tKey}CATEGORY`)}:</span>{t(`${tKey}${conditionFleet.category}`)}</p></div>
              </div>
            </div>

            <div id="fleet-dossier-details-table">
              <SimpleTablePage id="fleet-dossier-details-table"
                columns={[
                  <th key={0} data-field="number" onClick={(event) => this.onOrderChange(event)}>
                    {t('MANAGEMENT.FLEETS_TAB.DOSSIER_NUMBER')}&nbsp;<i className={this.getIconClass('number')}></i>
                  </th>,
                  <th key={1} data-field="vinChassisLicensePlate" onClick={(event) => this.onOrderChange(event)}>
                    {t('MANAGEMENT.FLEETS_TAB.VEHICLE')}&nbsp;<i className={this.getIconClass('vehicle')}></i>
                  </th>,
                  <th key={2} data-field="model" onClick={(event) => this.onOrderChange(event)}>
                    {t('MANAGEMENT.FLEETS_TAB.MODEL')}&nbsp;<i className={this.getIconClass('model')}></i>
                  </th>,
                  <th key={3} data-field="creationDate" onClick={(event) => this.onOrderChange(event)}>
                    {t('MANAGEMENT.FLEETS_TAB.CREATION_DATE')}&nbsp;<i className={this.getIconClass('creationDate')}/>
                  </th>,
                  <th key={4} data-field="lastUpdateDate" onClick={(event) => this.onOrderChange(event)}>
                    {t('MANAGEMENT.FLEETS_TAB.AUX_MODALS.LAST_UPDATE_DATE')}&nbsp;<i className={this.getIconClass('lastUpdateDate')}/>
                  </th>,
                  <th key={5} data-field="status" className='actions' onClick={(event) => this.onOrderChange(event)}>
                    {t(`${tKey}STATUS`)}&nbsp;<i className={this.getIconClass('status')}/>
                  </th>
                ]}
                rows={conditionDetails && conditionDetails.map((row, idx) => (
                  <tr key={idx}>
                    <td>{
                      row.urlToNavigate ? (
                        <Link to={`/dossier${row.urlToNavigate}`}>
                          {row.number}
                        </Link>
                      ) : row.number
                    }</td>
                    <td>{row.vinChassisLicensePlate}</td>
                    <td>{row.model}</td>
                    <td>{row.creationDate}</td>
                    <td>{row.lastUpdateDate}</td>
                    <td className='actions'>{<i className={'static-icon icon-action ' + (row.status ? 'iDocIcon-done-ok' : 'iDocIcon-warning')}/>}</td>
                  </tr>
                ))}
              ></SimpleTablePage>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className='flexInLine al-C'>
              <Button
                id='btn-close-fleet-delivery-select-charge-modal'
                className="_Btn accept"
                onClick={() => this.closeModal()}>
                {t(`${tKey}CLOSE`)}
              </Button>
            </Col>
          </Modal.Footer>
        </Modal>

      )
    } else {
      return null
    }
  }
}

export default reduxForm({
  form: 'conditionDetailsFleetModal'
})(ConditionDetailsFleetModal)
